import { Button } from '@nesso/ui/primitives/button';
import { DialogDescription, DialogFooter, DialogTitle } from '@nesso/ui/primitives/dialog';

import envelopeIllustration from '@/shared/assets/envelope-illustration.svg';
import { SUPPORT_EMAIL } from '@/shared/constants/support';

type Props = {
    title: string;
    email: string | undefined;
    onClose: () => void;
};

export function EmailVerificationNotice({ title, email, onClose }: Props) {
    return (
        <>
            <div className="flex flex-col items-center gap-4">
                <div className="py-4">
                    {/* The illustration ships with the Figma ink colour baked in; crushing it
                        to black and inverting is what carries it onto a dark card. */}
                    <img
                        src={envelopeIllustration}
                        alt=""
                        className="block h-[65.8px] w-24 max-w-none dark:brightness-0 dark:invert"
                    />
                </div>
                <div className="flex w-full flex-col gap-2">
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>
                        Check {email ? <span className="font-bold">{email}</span> : null} for your
                        verification link. If you don&rsquo;t receive it, message {SUPPORT_EMAIL}.
                    </DialogDescription>
                </div>
            </div>
            <DialogFooter>
                <Button className="w-full" onClick={onClose}>
                    Got it
                </Button>
            </DialogFooter>
        </>
    );
}
